var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "poll-input" }, [
    _c(
      "div",
      { staticClass: "poll-input__item" },
      [
        _vm._t(
          "customInput",
          [
            _c(
              "input",
              _vm._b(
                {
                  staticClass: "poll-input__input",
                  class: {
                    "poll-input__input--error": _vm.errors.has(_vm.name)
                  },
                  attrs: { autofocus: _vm.autofocus, type: "text" },
                  domProps: { value: _vm.value },
                  on: {
                    input: function($event) {
                      return _vm.$emit("input", $event.target.value)
                    },
                    keydown: function($event) {
                      return _vm.$emit("keydown", $event.target.value)
                    },
                    keyup: function($event) {
                      return _vm.$emit("keyup", $event.target.value)
                    }
                  }
                },
                "input",
                _vm.$props,
                false
              )
            )
          ],
          { error: _vm.errors.has(_vm.name) }
        ),
        _c(
          "label",
          {
            staticClass: "poll-input__label",
            class: { "is-active-label": _vm.value },
            attrs: { for: _vm.id }
          },
          [_vm._v(_vm._s(_vm.label) + " ")]
        ),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errors.has(_vm.name),
                expression: "errors.has(name)"
              }
            ],
            staticClass: "poll-input__error"
          },
          [_vm._v(_vm._s(_vm.errors.first(_vm.name)))]
        )
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d57a11c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d57a11c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/shared/components/CustomInputGroup.vue
// module id = 202
// module chunks = 4